<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/招聘.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">代工企业对大量一线工人进行数字化招聘和排岗优化</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>      某上市代工厂，一线车间工人的雇工数量从2020年六月起有了快速的增长；这一快速增长伴随着工厂对雇工来源所做的调整，即从原来以自主招工为主，转为主要使用劳务公司来输送。工人的离岗率出现了成倍的增加，为保有一万人的一线工人人数，每年需招收4万工人。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              使用企业的招工和用工历史数据，通过数据挖掘提供诊断性的状况与归因分析，并提供解决方案和业务抓手
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" >
          <p style="text-indent: 0;">使用部盾的分析平台和报告及看板生成系统：</p>
          <p>分析了离岗率的历史变动，并从雇工渠道、地域来源、年龄段、学历、打工经历、历史过往、季节和疫情因素等方面进行了归因分析</p>
          <p>建立了针对一线工人的离岗倾向模型，用于招工时对人员的筛选以及对存量雇工的区别性排岗</p>
          <p style="text-indent: 0;">建立了优化排岗算法并设计了业务操作界面</p>

        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/组4-2.png" style="width: 1200px;height;588px;" alt="">
        </div>
        <div style="padding-bottom: 80px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "zhaopin",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>